(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-shipping-info"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('product-shipping-info')) {
    class ProductShippingInfo extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.getAttribute('form-id'));
        this.priceIcon = this.querySelector('[data-shipping-price-icon]');
        this.priceText = this.querySelector('[data-shipping-price-text]');
        this.speedRow = this.querySelector('[data-shipping-speed-row]');
        this.speedText = this.querySelector('[data-shipping-speed-text]');
        this.data = this.#parseData();
        this.holidays = new Set(this.data.holidays || []);
        this.onVariantChange = this.#onVariantChange.bind(this);

        this.form?.addEventListener('variant:change', this.onVariantChange);
        this.#update(this.#getSelectedVariantId());
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.onVariantChange);
      }

      #parseData() {
        const payload = this.querySelector('[data-product-shipping-info-json]');

        if (!payload?.textContent) {
          return { variants: {}, messages: {}, holidays: [] };
        }

        try {
          return JSON.parse(payload.textContent);
        } catch (error) {
          console.warn('Unable to parse product shipping info JSON.', error);
          return { variants: {}, messages: {}, holidays: [] };
        }
      }

      #getSelectedVariantId() {
        const variantInput = this.form?.querySelector('input[name="id"]');

        return String(variantInput?.value || this.data.selectedVariantId || '');
      }

      #onVariantChange(event) {
        const variantId = event.detail?.variant?.id ? String(event.detail.variant.id) : this.#getSelectedVariantId();
        this.#update(variantId);
      }

      #update(variantId) {
        const variantData = this.data.variants?.[variantId] || this.data.variants?.[String(this.data.selectedVariantId)] || null;

        if (!variantData?.deliveryProfile) {
          return;
        }

        const priceResult = this.#resolvePrice(variantData.deliveryProfile);
        this.#renderPrice(priceResult);

        if (priceResult.isOversizedInternationalFallback || this.#shouldHideShippingSpeed(variantData)) {
          this.speedRow.hidden = true;
          this.speedText.textContent = '';
          return;
        }

        this.speedText.textContent = this.#buildShippingSpeedMessage();
        this.speedRow.hidden = false;
      }

      #resolvePrice(profile) {
        const marketCode = this.#getActiveMarketCode();
        const normalizedName = (profile.name || '').trim().toLowerCase();
        const profileGid = (profile.gid || '').trim();
        const isBlankProfile = !normalizedName && !profileGid;
        const isGeneralProfile = normalizedName === 'general profile' || isBlankProfile;
        const localizedText = (this.#isFrench() ? (profile.textFr || '').trim() : (profile.textEn || '').trim()) || (isGeneralProfile ? (this.data.messages.defaultGeneralProfile || '').trim() : '');
        const marketCost = this.#getMarketCost(profile.costs || {}, marketCode);
        const isDomesticMarket = marketCode === 'CA' || marketCode === 'US';

        if (isGeneralProfile) {
          if (isDomesticMarket && localizedText) {
            return {
              icon: 'package',
              fragments: [{ type: 'text', value: localizedText }],
              isOversizedInternationalFallback: false
            };
          }

          if (!isDomesticMarket && marketCost) {
            return {
              icon: 'worldwide',
              fragments: this.#buildTemplateCostFragments(this.data.messages.internationalFlatFee, marketCost),
              isOversizedInternationalFallback: false
            };
          }
        }

        if (profileGid === this.data.oversizedDomesticGid && isDomesticMarket && localizedText) {
          return {
            icon: 'package-dimensions',
            fragments: [{ type: 'text', value: localizedText }],
            isOversizedInternationalFallback: false
          };
        }

        if (localizedText && marketCost) {
          return {
            icon: 'package-dimensions',
            fragments: [
              { type: 'text', value: `${localizedText}: ` },
              { type: 'cost', value: marketCost }
            ],
            isOversizedInternationalFallback: false
          };
        }

        return {
          icon: 'package-dimensions',
          fragments: [
            { type: 'text', value: this.data.messages.oversizedPrefix },
            { type: 'link', value: this.data.messages.oversizedLinkText, href: `mailto:${this.data.supportEmail}` },
            { type: 'text', value: this.data.messages.oversizedSuffix }
          ],
          isOversizedInternationalFallback: true
        };
      }

      #shouldHideShippingSpeed(variantData) {
        return variantData?.requiresShipping === false || Number(variantData?.inventoryQuantity) <= 0;
      }

      #buildTemplateCostFragments(template, cost) {
        const [prefix = '', suffix = ''] = String(template || '').split('__PRICE__');
        const fragments = [];

        if (prefix) {
          fragments.push({ type: 'text', value: prefix });
        }

        fragments.push({ type: 'cost', value: cost });

        if (suffix) {
          fragments.push({ type: 'text', value: suffix });
        }

        return fragments;
      }

      #renderPrice(result) {
        const iconTemplate = this.querySelector(`[data-shipping-icon="${result.icon}"]`);

        if (iconTemplate) {
          this.priceIcon.replaceChildren(iconTemplate.content.cloneNode(true));
        }

        this.priceText.replaceChildren();

        result.fragments.forEach((fragment) => {
          if (fragment.type === 'link') {
            const link = document.createElement('a');
            link.href = fragment.href;
            link.className = 'product-shipping-info__link';
            link.textContent = fragment.value;
            this.priceText.append(link);
            return;
          }

          if (fragment.type === 'cost') {
            const cost = document.createElement('span');
            cost.className = 'product-shipping-info__metaobject-cost';
            cost.textContent = fragment.value;
            this.priceText.append(cost);
            return;
          }

          this.priceText.append(document.createTextNode(fragment.value));
        });
      }

      #buildShippingSpeedMessage() {
        const now = new Date();
        const storeParts = this.#getZonedParts(now, this.data.storeTimeZone);
        const storeDateKey = `${storeParts.year}-${storeParts.month}-${storeParts.day}`;
        const isBusinessDay = this.#isBusinessDay(storeDateKey);
        const isBeforeCutoff = Number(storeParts.hour) < Number(this.data.cutoffHour);

        if (isBusinessDay && isBeforeCutoff) {
          const cutoffDate = this.#zonedTimeToDate(
            {
              year: Number(storeParts.year),
              month: Number(storeParts.month),
              day: Number(storeParts.day),
              hour: Number(this.data.cutoffHour),
              minute: 0
            },
            this.data.storeTimeZone
          );

          return this.data.messages.shipsToday.replace('__CUTOFF__', this.#formatCutoff(cutoffDate));
        }

        const nextShippingDate = this.#getNextShippingDate(storeDateKey);
        const tomorrowKey = this.#addDays(storeDateKey, 1);

        if (nextShippingDate === tomorrowKey) {
          return this.data.messages.shipsTomorrow;
        }

        return this.data.messages.shipsWeekday.replace('__WEEKDAY__', this.#formatWeekday(nextShippingDate));
      }

      #getActiveMarketCode() {
        return String(this.data.country || this.data.market || '').toUpperCase();
      }

      #getMarketCost(costs, marketCode) {
        const normalizedMarketCode = String(marketCode || '').toUpperCase();

        switch (normalizedMarketCode) {
          case 'CA':
            return costs.ca || '';
          case 'US':
            return costs.us || '';
          case 'GB':
          case 'UK':
            return costs.uk || '';
          case 'SE':
          case 'SW':
            return costs.sw || '';
          case 'NO':
            return costs.no || '';
          case 'EU':
            return costs.eu || '';
          default:
            return this.#isEuropeanMarket(normalizedMarketCode) ? (costs.eu || '') : '';
        }
      }

      #isEuropeanMarket(marketCode) {
        return new Set([
          'AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR',
          'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SI', 'SK'
        ]).has(marketCode);
      }

      #isFrench() {
        return String(this.data.language || '').toLowerCase().startsWith('fr');
      }

      #formatCutoff(cutoffDate) {
        const timeZone = this.data.storeTimeZone;
        const parts = this.#getZonedParts(cutoffDate, timeZone);
        const hour = Number(parts.hour);
        const minute = Number(parts.minute);
        const zoneLabel = this.#getZoneLabel(timeZone, cutoffDate);

        if (this.#isFrench()) {
          if (minute === 0) {
            return `${hour} h ${zoneLabel}`;
          }

          return `${hour} h ${String(minute).padStart(2, '0')} ${zoneLabel}`;
        }

        const meridiem = hour >= 12 ? 'PM' : 'AM';
        const hour12 = ((hour + 11) % 12) + 1;
        const minuteDisplay = minute === 0 ? '' : `:${String(minute).padStart(2, '0')}`;

        return `${hour12}${minuteDisplay} ${meridiem} ${zoneLabel}`;
      }

      #getZoneLabel(timeZone, date) {
        const storeOffset = this.#getTimeZoneOffset(date, this.data.storeTimeZone);
        const localOffset = this.#getTimeZoneOffset(date, timeZone);
        const offsetHours = Math.round((localOffset - storeOffset) / 3600000);

        if (timeZone === this.data.storeTimeZone || timeZone === 'America/Toronto') {
          return this.#isFrench() ? 'HE' : 'ET';
        }

        if (timeZone.startsWith('America/')) {
          if (offsetHours === -1) {
            return this.#isFrench() ? 'HC' : 'CT';
          }

          if (offsetHours === -2) {
            return this.#isFrench() ? 'HR' : 'MT';
          }

          if (offsetHours === -3) {
            return this.#isFrench() ? 'HP' : 'PT';
          }

          if (offsetHours === 0) {
            return this.#isFrench() ? 'HE' : 'ET';
          }
        }

        const timeZoneName = new Intl.DateTimeFormat(this.#isFrench() ? 'fr-CA' : 'en-US', {
          timeZone,
          timeZoneName: 'short'
        })
          .formatToParts(date)
          .find((part) => part.type === 'timeZoneName')?.value;

        return timeZoneName || (this.#isFrench() ? 'HE' : 'ET');
      }

      #getZonedParts(date, timeZone) {
        const formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });

        return formatter.formatToParts(date).reduce((accumulator, part) => {
          if (part.type !== 'literal') {
            accumulator[part.type] = part.value;
          }

          return accumulator;
        }, {});
      }

      #getTimeZoneOffset(date, timeZone) {
        const parts = this.#getZonedParts(date, timeZone);
        const utcTimestamp = Date.UTC(
          Number(parts.year),
          Number(parts.month) - 1,
          Number(parts.day),
          Number(parts.hour),
          Number(parts.minute),
          Number(parts.second)
        );

        return utcTimestamp - date.getTime();
      }

      #zonedTimeToDate(parts, timeZone) {
        const utcGuess = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, 0));
        let offset = this.#getTimeZoneOffset(utcGuess, timeZone);
        let zonedDate = new Date(utcGuess.getTime() - offset);
        const refinedOffset = this.#getTimeZoneOffset(zonedDate, timeZone);

        if (refinedOffset !== offset) {
          offset = refinedOffset;
          zonedDate = new Date(utcGuess.getTime() - offset);
        }

        return zonedDate;
      }

      #dateFromKey(dateKey) {
        const [year, month, day] = dateKey.split('-').map(Number);

        return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
      }

      #addDays(dateKey, days) {
        const date = this.#dateFromKey(dateKey);
        date.setUTCDate(date.getUTCDate() + days);

        return date.toISOString().slice(0, 10);
      }

      #isBusinessDay(dateKey) {
        const date = this.#dateFromKey(dateKey);
        const dayOfWeek = date.getUTCDay();

        return dayOfWeek >= 1 && dayOfWeek <= 5 && !this.holidays.has(dateKey);
      }

      #getNextShippingDate(currentDateKey) {
        let candidate = this.#addDays(currentDateKey, 1);
        let guard = 0;

        while (!this.#isBusinessDay(candidate) && guard < 14) {
          candidate = this.#addDays(candidate, 1);
          guard += 1;
        }

        return candidate;
      }

      #formatWeekday(dateKey) {
        return new Intl.DateTimeFormat(this.#isFrench() ? 'fr-CA' : 'en-US', {
          weekday: 'long',
          timeZone: 'UTC'
        }).format(this.#dateFromKey(dateKey));
      }
    }

    window.customElements.define('product-shipping-info', ProductShippingInfo);
  }
  } catch(e) { console.error(e); }
})();

})();
